import type { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '4rem',

    tabletLarge: {
        paddingBottom: '4rem',
    },

    desktop1200: {
        flexDirection: 'row',
        paddingBottom: '4rem',
    },
});

export const contentContainer: TRuleWithTheme = () => ({
    width: '100%',
    desktop1200: {
        width: '50%',
    },
});

export const imageContainer: TRuleWithTheme = () => ({
    width: '100%',
    marginTop: '1.5rem',
    desktop1200: {
        maxWidth: '43.5rem',
        maxHeight: '30rem',
        width: '50%',
        objectFit: 'cover',
        marginLeft: '1.5rem',
        marginTop: 0,
    },
});

export const image: TRuleWithTheme = () => ({
    width: '100%',
});
